import MediaInserterAttachFileButton from '@intercom/embercom-composer/components/media-inserter-attach-file-button';
export default MediaInserterAttachFileButton;
